const tokenTestAddress = 'https://management.retorik.ai/api/getAgents';
const agentsFetchAddress = 'https://management.retorik.ai/api/getAgents';
const openIdAddress = 'https://auth.retorik.ai/.well-known/openid-configuration';

export {
    tokenTestAddress,
    agentsFetchAddress,
    openIdAddress
}